import Input from 'components/Form/Input'
import Label from 'components/Form/Label'
import Select from 'components/Select'
import {
  FlexWrap,
  FormItem,
  SelectInputDiv,
  StyledInput,
} from 'modules/Users/Partials/AddUserDrawer/Partials/AddUserForm/styles'
import React, { Fragment } from 'react'
import { IsValidEmail } from 'utils/emailValidation'
import { debounce } from 'lodash'

const AddUserForm = ({ userRole, setCountryCodeSearch, countryCodeList }) => {
  const handleSearch = debounce((value) => {
    setCountryCodeSearch(value)
  }, 500)
  return (
    <Fragment>
      <FlexWrap spaceBetween gap="25px">
        <FlexWrap width="49%">
          <Input
            type="text"
            width="100%"
            name={'firstName'}
            label="First Name"
            optional={'*'}
            placeholder="Eg: Vikram"
            maxLength={120}
            rules={[
              () => ({
                validator(_, value) {
                  if (!value) {
                    return Promise.reject(new Error(`Please enter first name!`))
                  }
                  if (value && value.trim() === '') {
                    return Promise.reject(new Error('Please enter first name!'))
                  }
                  if (value && /\d/.test(value)) {
                    return Promise.reject(
                      new Error('First Name cannot contain numbers')
                    )
                  }
                  return Promise.resolve()
                },
              }),
            ]}
          />
        </FlexWrap>
        <FlexWrap width="49%">
          <Input
            type="text"
            width="100%"
            name={'lastName'}
            label="Last Name"
            optional={'*'}
            placeholder="Eg: Sharma"
            maxLength={20}
            rules={[
              () => ({
                validator(_, value) {
                  if (!value) {
                    return Promise.reject(new Error(`Please enter last name!`))
                  }
                  if (value?.trim() === '') {
                    return Promise.reject(new Error(`Please enter last name!`))
                  }
                  if (value && /\d/.test(value)) {
                    return Promise.reject(
                      new Error('Last Name cannot contain numbers')
                    )
                  }
                  return Promise.resolve()
                },
              }),
            ]}
          />
        </FlexWrap>
      </FlexWrap>

      <FormItem
        name={'adminRoleId'}
        rules={[
          {
            required: true,
            message: 'Please select Any One Role',
          },
        ]}
      >
        <Select
          OptionData={Array.isArray(userRole) ? userRole?.filter(r => r?.journey === 'INSTITUTE') : []}
          label="User Role *"
          valueParam="id"
          nameParam="name"
          placeholder="Select"
        />
      </FormItem>

      <Input
        width="100%"
        name={'email'}
        label="Email ID"
        optional={'*'}
        placeholder="Eg. vikram.sharma@plugin.com"
        rules={[
          () => ({
            validator(_, value) {
              let isValid = IsValidEmail(value)
              if (!isValid) {
                return Promise.reject(new Error(`Please Enter Valid Email`))
              }

              return Promise.resolve()
            },
          }),
        ]}
      />

      <div>
        <Label required={true}>Phone No *</Label>

        <SelectInputDiv borderleft={true} margintop="8px">
          <FormItem
            name={'countryCode'}
            rules={[
              {
                required: true,
                message: 'Please select Any One Country Code',
              },
            ]}
            dependencies={['countryCode']}
          >
            <Select
              showSearch
              allowClear
              OptionData={countryCodeList}
              nameParam="phone_code"
              valueParam="phone_code"
              bordered={false}
              name={'countryCode'}
              optionFilterProp="phone_code"
              filterOption={(input, option) => {
                const phoneCode = option?.children?.toString?.() || option?.phone_code?.toString?.() || ''
                return phoneCode.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }}
              onSearch={value => handleSearch(value)}
              onSelect={() => {
                setTimeout(() => setCountryCodeSearch(''), 1000); // Wait for fetch
              }}
              placeholder="+91"
            />
          </FormItem>
          <StyledInput
            width="100%"
            type="number"
            name={'phoneNumber'}
            placeholder="Eg: 9999999999"
            rules={[
              {
                required: true,
                message: 'Please Enter phone number!',
              },
              {
                min: 10,
                max: 10,
                message: 'Please enter valid phone number',
              },
            ]}
            onKeyDown={event =>
              ['e', 'E', '+', '-']?.includes(event.key) && event.preventDefault()
            }
            onInput={event => {
              const { value } = event.target
              event.target.value = value?.replace(/[^\d]/g, '')
            }}
          />
        </SelectInputDiv>
      </div>

      <div>
        <Label>LandLine Number</Label>
        <FormItem name={'landlineNumber'}>
          <Input
            width="100%"
            type="number"
            name={'landlineNumber'}
            placeholder="Eg: +91 22 1234 5678"
            rules={[
              {
                required: false,
                message: 'Please Enter LandLine Number!',
              },
              {
                min: 10,
                max: 15,
                message: 'Please enter valid  LandLine Number',
              },
            ]}
          />
        </FormItem>
      </div>
    </Fragment>
  )
}

export default AddUserForm
